/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Owner_PageInputs */

const vi_media_owner_page = /** @type {(inputs: Media_Owner_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang`)
};

/**

* @param {Media_Owner_PageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_owner_page = /** @type {((inputs?: Media_Owner_PageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Owner_PageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_owner_page(inputs)
});